import { Price, Rate, User } from '@entities/dtos';
import { v4 as uuidv4 } from 'uuid';

const { VITE_PROJECTS_URL } = import.meta.env;

export class AdminProjectDTO {
  id;
  dir;
  rate;
  sale;
  title;
  stage;
  costs;
  price;
  userId;
  isChat;
  isPaid;
  rating;
  roomId;
  archive;
  estimated;
  user = {};
  paidHours;
  isDeleted;
  renderImage;
  sketchImage;
  followingId;
  followingData;
  filesInstance;
  interviewerId;
  isMessagesSend;
  executors = [];
  workingHoursSum;
  html_description;
  currentStepsHours;
  reason_for_deletion;
  expectedCostMaxRate;
  notificationsToUser = [];
  illustration_format;
  isAcceptedInterviewer;
  expectedCostHourlyRate;
  createdAt;

  constructor(option) {
    if (!option) {
      option = {};
    }

    this.id = option?.id || uuidv4();
    this.dir = option.dir;
    this.title = option.title;
    this.roomId = option.roomId;
    this.costs = option?.costs || [];
    this.estimated = option?.estimated || {};
    this.rating = option.rating;
    this.userId = option.userId;
    this.isPaid = option.isPaid;
    this.sale = option?.sale || 0;
    this.stage = +option?.stage || 1;
    this.paidHours = option.paidHours;
    this.isDeleted = option.isDeleted;
    this.isChat = +option?.isChat || 1;
    this.isMessagesSend = option?.isMessagesSend || 1;
    this.filesInstance = option.filesInstance;
    this.html_description = option.html_description;
    this.interviewerId = +option?.interviewerId || null;
    this.illustration_format = option.illustration_format;
    this.expectedCostMaxRate = option?.expectedCostMaxRate || 0;
    this.workingHoursSum = `${option.workingHoursSum || '0.0'}`;
    this.isAcceptedInterviewer = +option?.isAcceptedInterviewer || 1;
    this.expectedCostHourlyRate = option?.expectedCostHourlyRate || 0;

    this.user = new User(option.user);
    this.price = new Price(option.price);
    this.rate = new Rate(option.rate, option.rate_type);

    this.archive = option.archive;
    this.followingId = option?.followingId ? option.followingId : 2;

    this.createdAt = option.createdAt;

    this.reason_for_deletion =
    // eslint-disable-next-line
      option.reason_for_deletion == 'null' || option.reason_for_deletion === ''
        ? null
        : option.reason_for_deletion;

    const followingData = option?.followingData
      ? option.followingData.replaceAll('\\', '').replaceAll('&quot;', '"')
      : '[]';

    this.followingData = JSON.parse(followingData);

    const currentStepsHours = option?.currentStepsHours
      ? option.currentStepsHours.replaceAll('\\', '').replaceAll('&quot;', '"')
      : '[]';

    this.currentStepsHours = JSON.parse(currentStepsHours);

    const notificationToUser = JSON.parse(option?.notificationsToUser) || [];
    this.notificationsToUser = notificationToUser;

    if (option.executors && option.executors.length) {
      this.executors = option.executors.map((executor) => new User(executor));
    }

    if (option.sketchImage && option.sketchImage === 'null') {
      this.sketchImage = null;
    } else {
      this.sketchImage = option.sketchImage;
    }

   if (!option.renderImage) {
      this.renderImage = null;
      this.renderImageUrl = '/images/project/default.jpg';

    } else {
      this.renderImage = option.renderImage;
      this.renderImageUrl = `${VITE_PROJECTS_URL}/${this.dir}/${this.renderImage}`;

    }
  }
}
